interface RunCalcParams {
    distance: number
    lane: number
    time: number
    elapsedTime: number
    height?: number
    initialRotationX?: number
    initialRotationZ?: number
    clockwise?: boolean
    positionsStart: [number, number, number]
    rotationsStart: [number, number, number]
}

export const RunCalc = ({
    distance,
    lane,
    time,
    elapsedTime,
    height = 0.1,
    initialRotationX = 0,
    initialRotationZ = 0,
    positionsStart,
    rotationsStart,
    clockwise = false,
}: RunCalcParams): { position: [number, number, number]; rotation: [number, number, number]; segment: number } => {

    const laneRadius = 36.8 + (lane - 1) * 1.22
    const straightLength = 84.39
    const curveLength = Math.PI * laneRadius
    const lapLength = 2 * curveLength + 2 * straightLength

    const speed = distance / time
    const covered = Math.min(elapsedTime * speed, distance)
    const coveredInLap = covered % lapLength

    const dir = clockwise ? -1 : 1
    const startAngle = clockwise ? Math.PI / 2 : -Math.PI / 2

    let x = 0
    let z = 0
    let rotationY = 0
    let segment = 1

    if (coveredInLap < curveLength) {
        const t = coveredInLap / curveLength
        const angle = startAngle + dir * t * Math.PI
        x = -laneRadius * Math.cos(angle)
        z = laneRadius * Math.sin(angle)
        rotationY = -Math.PI / 2 + t * Math.PI
        segment = 1
    } else if (coveredInLap < curveLength + straightLength) {
        const d = coveredInLap - curveLength
        const angleEndArc1 = startAngle + dir * Math.PI
        const endXArc1 = -laneRadius * Math.cos(angleEndArc1)
        const endZArc1 = laneRadius * Math.sin(angleEndArc1)
        x = endXArc1 + dir * d
        z = endZArc1
        rotationY = dir > 0 ? Math.PI / 2 : -Math.PI / 2
        segment = 2
    } else if (coveredInLap < 2 * curveLength + straightLength) {
        const d = coveredInLap - (curveLength + straightLength)
        const t = d / curveLength
        const angleStartArc2 = startAngle + dir * Math.PI
        const angle = angleStartArc2 + dir * t * Math.PI
        x = -laneRadius * Math.cos(angle) + dir * straightLength
        z = laneRadius * Math.sin(angle)
        rotationY = Math.PI / 2 + t * Math.PI
        segment = 3
    } else {
        const d = coveredInLap - (2 * curveLength + straightLength)
        const angleEndArc2 = startAngle + dir * 2 * Math.PI
        const endXArc2 = -laneRadius * Math.cos(angleEndArc2) + dir * straightLength
        const endZArc2 = laneRadius * Math.sin(angleEndArc2)
        x = endXArc2 - dir * d
        z = endZArc2
        rotationY = dir > 0 ? -Math.PI / 2 : Math.PI / 2
        segment = 4
    }

    return {
        position: [(x / 10) - 4.23, height, z / 10],
        rotation: [initialRotationX, rotationY, initialRotationZ],
        segment
    }
}
